import React, { Component } from 'react'
import {connect} from 'react-redux'
import moment from 'moment'

import { saveClub } from '../../actions/Club'

import Modal from '../Modal'

import { countries } from '../../geo.json'

class EditClub extends Component {
  saveClub () {
    const c = this.state
    this.props.saveClub({
      name: c.name,
      address: c.address,
      postal_code: c.postal_code,
      city: c.city,
      country: c.country,
      fiscal_code: c.fiscal_code,
      vat: c.vat,
      iban: c.iban,
      start_date: (c.start_date !== '') ? moment.utc(c.start_date).startOf('day').unix() : null,
      end_date: (c.end_date !== '') ? moment.utc(c.end_date).startOf('day').unix() : null,
      email: c.email,
      email_name: c.email_name
    })
  }
  componentWillMount () {
    const c = this.props.info
    this.setState({
      name: c.name,
      address: c.address,
      postal_code: c.postal_code,
      city: c.city,
      country: c.country,
      fiscal_code: c.fiscal_code,
      vat: c.vat,
      iban: c.iban,
      start_date: (c.start_date !== '') ? moment.unix(c.start_date).format('YYYY-MM-DD') : '',
      end_date: (c.end_date !== '') ? moment.unix(c.end_date).format('YYYY-MM-DD') : '',
      email: c.email,
      email_name: c.email_name
    })
  }
  render () {
    const { ajaxStatus } = this.props.club
    const c = this.state
    return (
      <Modal>
        <h3>Modifica anagrafica</h3>
        <button
          className="lnk-close-modal"
          onClick={() => this.props.hideModal()}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        <label>
            Nome
          <input
            type="text"
            placeholder="Nome"
            onChange={event => this.setState({ name: event.target.value })}
            value={c.name}
          />
        </label>
        <label>
            Indirizzo
          <input
            type="text"
            placeholder="Indirizzo"
            onChange={event => this.setState({ address: event.target.value })}
            value={c.address}
          />
        </label>
        <label>
            CAP
          <input
            type="number"
            placeholder="CAP"
            onChange={event => this.setState({ postal_code: event.target.value })}
            value={c.postal_code}
          />
        </label>
        <label>
            Città
          <input
            type="text"
            placeholder="Città"
            onChange={event => this.setState({ city: event.target.value })}
            value={c.city}
          />
        </label>
        <label>
          Provincia
          <select
            onChange={event => this.setState({ country: event.target.value })}
            value={this.state.country}
          >
            <option value=''></option>
            {
              countries.map((c, index) => {
                return (
                  <option key={index} value={c.label}>
                    {c.label}
                  </option>
                )
              })
            }
          </select>
        </label>
        <label>
            Codice fiscale
          <input
            type="text"
            placeholder="Codice fiscale"
            onChange={event => this.setState({ fiscal_code: event.target.value })}
            value={c.fiscal_code}
          />
        </label>
        <label>
            Partita IVA
          <input
            type="text"
            placeholder="Partita IVA"
            onChange={event => this.setState({ vat: event.target.value })}
            value={c.vat}
          />
        </label>
        <label>
            Iban
          <input
            type="text"
            placeholder="Iban"
            onChange={event => this.setState({ iban: event.target.value })}
            value={c.iban}
          />
        </label>
        <label>
            Inizio anno fiscale
          <input
            type="date"
            placeholder="Inizio anno fiscale"
            disabled
            onChange={event => this.setState({ start_date: event.target.value })}
            value={c.start_date}
          />
        </label>
        <label>
            Fine anno fiscale
          <input
            type="date"
            placeholder="Fine anno fiscale"
            disabled
            onChange={event => this.setState({ end_date: event.target.value })}
            value={c.end_date}
          />
        </label>
        <label>
            E-mail
          <input
            type="email"
            placeholder="E-mail"
            onChange={event => this.setState({ email: event.target.value })}
            value={c.email}
          />
        </label>
        <label>
            Nome e-mail
          <input
            type="text"
            placeholder="Nome e-mail"
            onChange={event => this.setState({ email_name: event.target.value })}
            value={c.email_name}
          />
        </label>
        <ul className="submit-btn">
          <li>
            <span className="ajax-error">{ajaxStatus}</span>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.saveClub()}
            >
              salva
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { saveClub })(EditClub)



// WEBPACK FOOTER //
// ./src/components/Club/EditClub.js